<template>
  <div class="ibox">
    <div class="ibox-title">
      <h5>Hosting</h5>
      <div class="ibox-tools pull-right">
        <a class="collapse-link">
          <i class="fa fa-chevron-up"></i>
        </a>
      </div>
    </div>
    <div class="ibox-content">
      <table class="table-hover table" id="hosting-table">
        <thead>
        <tr>
          <th>Host</th>
          <th>Network</th>
          <th>Domains</th>
          <th>IPs</th>
          <th></th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      table: null
    }
  },
  computed: {
    ...mapGetters({
      hosts: 'getHosts',
      filters: 'getViewFilters'
    })
  },
  mixins: [Query],
  mounted () {
    this.$store.dispatch('loadHosts', this.buildQuery(this.filters)).then(() => { this.drawTable() })
  },
  watch: {
    hosts () {
      this.drawTable()
    },
    filters () {
      this.$store.dispatch('loadHosts', this.buildQuery(this.filters)).then(() => { this.drawTable() })
    }
  },
  methods: {
    drawTable () {
      this.table = $('#hosting-table').DataTable()
      this.table.rows().remove()
      this.hosts.forEach(host => {
        this.table.row.add([
          host.name,
          host.client ? host.client.name : '/',
          0,
          0,
          0
        ])
      })
      this.table.draw(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/Hosting.vue